/* Vitality Pack LP (page.vitality-pack-lp). Vanilla JS, no dependencies. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------- Scroll to buy box ---------- */
  function bindScrollToBuyBox() {
    document.querySelectorAll('[data-lp-scroll-to-buybox]').forEach(function (el) {
      if (el.__lpScroll) return;
      el.__lpScroll = true;
      el.addEventListener('click', function (event) {
        var target = document.querySelector('[data-lp-buybox]');
        if (!target) return;
        event.preventDefault();
        var header = document.querySelector('.header-sections-container');
        var offset = (header ? header.getBoundingClientRect().height : 0) + 16;
        var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: top, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      });
    });
  }

  /* ---------- Scroll reveal (fade up once, 80ms stagger between siblings) and count-up numbers ---------- */
  function bindReveal() {
    var items = Array.prototype.slice.call(document.querySelectorAll('.lp-reveal, .lp-draw'));
    var designMode = window.Shopify && window.Shopify.designMode;
    if (!items.length) return;
    /* Stagger: siblings inside a [data-lp-stagger] container reveal 80ms apart, capped at six steps */
    document.querySelectorAll('[data-lp-stagger]').forEach(function (group) {
      var kids = Array.prototype.filter.call(group.children, function (c) { return c.classList.contains('lp-reveal') || c.querySelector('.lp-reveal'); });
      kids.forEach(function (kid, i) {
        var target = kid.classList.contains('lp-reveal') ? kid : kid.querySelector('.lp-reveal');
        if (target) target.style.setProperty('--lp-delay', Math.min(i, 6) * 80 + 'ms');
      });
    });
    if (reduceMotion.matches || designMode || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  function formatCount(value, decimals, suffix) {
    var text = decimals ? value.toFixed(decimals) : Math.round(value).toLocaleString('en-AU');
    return text + (suffix || '');
  }
  function initCountUp() {
    var els = document.querySelectorAll('[data-lp-countup]');
    if (!els.length) return;
    var motion = !reduceMotion.matches && !(window.Shopify && window.Shopify.designMode) && 'IntersectionObserver' in window;
    if (!motion) return; /* the final value is already in the markup */
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        var el = entry.target;
        var target = parseFloat(el.getAttribute('data-target')) || 0;
        var decimals = parseInt(el.getAttribute('data-decimals') || '0', 10);
        var suffix = el.getAttribute('data-suffix') || '';
        var duration = 1400;
        var start = null;
        function frame(ts) {
          if (start === null) start = ts;
          var t = Math.min((ts - start) / duration, 1);
          var eased = 1 - Math.pow(1 - t, 3);
          el.textContent = formatCount(target * eased, decimals, suffix);
          if (t < 1) window.requestAnimationFrame(frame); else el.textContent = formatCount(target, decimals, suffix);
        }
        window.requestAnimationFrame(frame);
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) {
      var decimals = parseInt(el.getAttribute('data-decimals') || '0', 10);
      el.textContent = formatCount(0, decimals, el.getAttribute('data-suffix') || '');
      io.observe(el);
    });
  }

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    var gallery = root.querySelector('[data-lp-gallery]');
    if (!gallery) return;
    var track = gallery.querySelector('[data-lp-track]');
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-lp-slide]'));
    var dots = gallery.querySelectorAll('[data-lp-dot]');
    var thumbs = gallery.querySelectorAll('[data-lp-thumb]');
    var prev = gallery.querySelector('[data-lp-prev]');
    var next = gallery.querySelector('[data-lp-next]');
    var current = 0;

    function setCurrent(i) {
      current = i;
      dots.forEach(function (d, n) { n === i ? d.setAttribute('aria-current', 'true') : d.removeAttribute('aria-current'); });
      thumbs.forEach(function (t, n) { n === i ? t.setAttribute('aria-current', 'true') : t.removeAttribute('aria-current'); });
      if (prev) prev.hidden = i === 0;
      if (next) next.hidden = i === slides.length - 1;
    }
    function goTo(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      setCurrent(i);
    }
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== current) setCurrent(i);
      });
    }, { passive: true });
    dots.forEach(function (d) { d.addEventListener('click', function () { goTo(+d.getAttribute('data-lp-dot')); }); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(+t.getAttribute('data-lp-thumb')); }); });
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
    });
    /* Lets the buy box move the gallery to the slide tied to the picked pack */
    root.__lpGalleryShowVariant = function (variantId) {
      for (var n = 0; n < slides.length; n++) {
        if (slides[n].getAttribute('data-variant-id') === String(variantId)) { goTo(n); return; }
      }
    };
    setCurrent(0);
  }

  /* ---------- Buy box ---------- */
  function initBuyBox() {
    var root = document.querySelector('[data-lp-buybox]');
    if (!root || root.__lpInit) return;
    root.__lpInit = true;

    var dataEl = root.querySelector('script[data-lp-product]');
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var variants = {};
    data.variants.forEach(function (v) { variants[String(v.id)] = v; });
    var money = new Intl.NumberFormat('en-AU', { style: 'currency', currency: data.currency || 'AUD' });
    function fmt(cents) { return money.format(cents / 100); }

    var state = { variantId: root.getAttribute('data-default-variant'), type: 'subscribe' };

    var els = {
      packs: root.querySelectorAll('[data-lp-pack]'),
      types: root.querySelectorAll('[data-lp-type]'),
      priceWas: root.querySelector('[data-lp-price-was]'),
      priceNow: root.querySelector('[data-lp-price-now]'),
      subWas: root.querySelector('[data-lp-sub-was]'),
      subPrice: root.querySelector('[data-lp-sub-price]'),
      delivery: root.querySelector('[data-lp-delivery]'),
      saveLine: root.querySelector('[data-lp-save-line]'),
      saveTag: root.querySelector('[data-lp-save-tag]'),
      oneCompare: root.querySelector('[data-lp-one-compare]'),
      onePrice: root.querySelector('[data-lp-one-price]'),
      subCard: root.querySelector('[data-lp-type-card="subscribe"]'),
      error: root.querySelector('[data-lp-error]'),
      live: root.querySelector('[data-lp-live]')
    };
    var addButtons = Array.prototype.slice.call(document.querySelectorAll('[data-lp-add]'));
    var stickyPack = document.querySelector('[data-lp-sticky-pack]');
    var stickyPrice = document.querySelector('[data-lp-sticky-price]');

    function currentVariant() { return variants[state.variantId]; }
    function currentAlloc(v) { return v && v.allocations && v.allocations[0] ? v.allocations[0] : null; }
    function tpl(el, percent, saving) {
      return el.getAttribute('data-template').split('[percent]').join(percent).split('[amount]').join(fmt(saving));
    }

    function render() {
      var v = currentVariant();
      var a = currentAlloc(v);
      if (!a && state.type === 'subscribe') state.type = 'onetime';
      var sub = state.type === 'subscribe' && a;

      /* Pack options show the price for the chosen purchase type */
      Object.keys(variants).forEach(function (id) {
        var vv = variants[id];
        var aa = currentAlloc(vv);
        var el = root.querySelector('[data-lp-pack-price="' + id + '"]');
        if (el) el.textContent = fmt(state.type === 'subscribe' && aa ? aa.price : vv.price);
        var card = root.querySelector('[data-lp-pack-card="' + id + '"]');
        if (card) card.classList.toggle('is-selected', id === state.variantId);
      });
      els.packs.forEach(function (input) { input.checked = input.value === state.variantId; });

      /* Price line: on subscribe the one-time price is struck, compare-at shows on the one-time line only */
      els.priceNow.textContent = fmt(sub ? a.price : v.price);
      els.priceWas.hidden = !sub;
      if (sub) els.priceWas.textContent = fmt(v.price);

      /* Subscribe card */
      els.subCard.querySelector('input').disabled = !a;
      els.subCard.classList.toggle('is-selected', state.type === 'subscribe');
      if (a) {
        els.subWas.textContent = fmt(v.price);
        els.subPrice.textContent = fmt(a.price);
        els.delivery.textContent = a.planName;
        els.saveLine.textContent = tpl(els.saveLine, a.percent, v.price - a.price);
        els.saveTag.textContent = tpl(els.saveTag, a.percent, v.price - a.price);
      }

      /* One-time card */
      var oneCard = root.querySelector('[data-lp-type-card="onetime"]');
      oneCard.classList.toggle('is-selected', state.type === 'onetime');
      els.onePrice.textContent = fmt(v.price);
      var hasCompare = v.compareAt > v.price;
      els.oneCompare.hidden = !hasCompare;
      if (hasCompare) els.oneCompare.textContent = fmt(v.compareAt);
      els.types.forEach(function (input) { input.checked = input.value === state.type; });

      /* Buttons: same selection everywhere */
      addButtons.forEach(function (btn) {
        btn.setAttribute('data-pack', v.title);
        btn.setAttribute('data-plan', sub ? a.planName : '');
        btn.setAttribute('data-variant-id', v.id);
        btn.setAttribute('data-selling-plan-id', sub ? a.planId : '');
        btn.disabled = !v.available;
      });

      if (stickyPack) stickyPack.textContent = v.title + (sub ? ' · ' + a.planName : '');
      if (stickyPrice) stickyPrice.textContent = fmt(sub ? a.price : v.price);

      document.dispatchEvent(new CustomEvent('lp:selection', { detail: { variantId: v.id, pack: v.title, plan: sub ? a.planName : null, sellingPlanId: sub ? a.planId : null } }));
    }

    els.packs.forEach(function (input) {
      input.addEventListener('change', function () {
        state.variantId = input.value;
        render();
        if (root.__lpGalleryShowVariant) root.__lpGalleryShowVariant(state.variantId); /* gallery follows the picked pack */
      });
    });
    els.types.forEach(function (input) {
      input.addEventListener('change', function () { state.type = input.value; render(); });
    });

    /* Health warnings toggle */
    var toggle = root.querySelector('[data-lp-warnings-toggle]');
    if (toggle) {
      toggle.addEventListener('click', function () {
        var open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!open));
        document.getElementById(toggle.getAttribute('aria-controls')).hidden = open;
      });
    }

    /* ---------- Add to cart: theme cart, then the Rebuy Smart Cart ---------- */
    function openSmartCart() {
      return new Promise(function (resolve) {
        var waited = 0;
        (function tryOpen() {
          var R = window.Rebuy;
          if (R && R.SmartCart && typeof R.SmartCart.show === 'function') {
            try {
              if (R.Cart && typeof R.Cart.fetchShopifyCart === 'function') {
                R.Cart.fetchShopifyCart(function () { R.SmartCart.show(); });
              } else {
                R.SmartCart.show();
              }
              resolve(true);
              return;
            } catch (e) { /* fall through to retry */ }
          }
          waited += 100;
          if (waited >= 3000) { resolve(false); return; }
          setTimeout(tryOpen, 100);
        })();
      });
    }

    function setBusy(btn, busy) {
      if (busy) { btn.style.minWidth = btn.offsetWidth + 'px'; }
      btn.classList.toggle('is-loading', busy);
      btn.setAttribute('aria-busy', String(busy));
      if (!busy) btn.style.minWidth = '';
    }
    function showError(show) {
      els.error.hidden = !show;
    }

    async function addToCart(btn) {
      var v = currentVariant();
      var a = currentAlloc(v);
      var item = { id: v.id, quantity: 1 };
      if (state.type === 'subscribe' && a) item.selling_plan = a.planId;

      showError(false);
      setBusy(btn, true);
      var ok = false;
      try {
        if (window._cart && typeof window._cart.add === 'function') {
          var result = await window._cart.add({ items: [item] });
          ok = !(result && result.cart_error);
        } else {
          var res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [item] })
          });
          ok = res.ok;
          if (ok) document.dispatchEvent(new CustomEvent('productAddedToCart', { detail: { items: [item] } }));
        }
      } catch (e) { ok = false; }

      if (!ok) {
        setBusy(btn, false);
        showError(true);
        return;
      }
      var opened = await openSmartCart();
      setBusy(btn, false);
      if (!opened) {
        var label = btn.querySelector('.lp-btn__label');
        var original = label.textContent;
        label.textContent = 'Added';
        if (els.live) els.live.textContent = 'Added to cart';
        setTimeout(function () { label.textContent = original; }, 1500);
      }
    }

    addButtons.forEach(function (btn) {
      btn.addEventListener('click', function () { addToCart(btn); });
    });

    initGallery(root);
    render();
  }

  /* ---------- Sticky bar ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-lp-sticky]');
    var buybox = document.querySelector('[data-lp-buybox]');
    if (!bar || !buybox || bar.__lpInit || !('IntersectionObserver' in window)) return;
    bar.__lpInit = true;
    bar.hidden = false;

    var watched = [buybox].concat(Array.prototype.slice.call(document.querySelectorAll('[data-lp-hide-sticky]')));
    var footer = document.querySelector('footer');
    if (footer) watched.push(footer);

    var inView = new Map();
    var buyboxPassed = false;

    function update() {
      var anyInView = false;
      inView.forEach(function (v) { if (v) anyInView = true; });
      var show = buyboxPassed && !anyInView;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', String(!show));
      if (show) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        inView.set(entry.target, entry.isIntersecting);
        if (entry.target === buybox) {
          /* Passed once it has scrolled above the viewport, not before it is reached */
          buyboxPassed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        }
      });
      update();
    });
    watched.forEach(function (el) { io.observe(el); });
    update();
  }

  /* ---------- Reviews carousel: user driven only, no auto advance ---------- */
  function initCarousels() {
    document.querySelectorAll('[data-lp-carousel]').forEach(function (root) {
      if (root.__lpInit) return;
      root.__lpInit = true;
      var track = root.querySelector('[data-lp-carousel-track]');
      var prev = root.querySelector('[data-lp-carousel-prev]');
      var next = root.querySelector('[data-lp-carousel-next]');
      var items = track.querySelectorAll('[data-lp-carousel-item]');
      var dots = root.querySelectorAll('.lp-carousel__dot');
      if (!items.length) return;

      function step() {
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return items[0].getBoundingClientRect().width + gap;
      }
      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.hidden = track.scrollLeft <= 2;
        if (next) next.hidden = track.scrollLeft >= max;
        var i = Math.min(items.length - 1, Math.max(0, Math.round(track.scrollLeft / step())));
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      }
      function move(dir) {
        track.scrollBy({ left: dir * step(), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { move(-1); });
      if (next) next.addEventListener('click', function () { move(1); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); move(1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); move(-1); }
      });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- Benefit cards: tap to expand on mobile when the copy is longer than three lines ---------- */
  function initBenefits() {
    var cards = document.querySelectorAll('[data-lp-benefit]');
    if (!cards.length) return;

    function measure() {
      cards.forEach(function (card) {
        var text = card.querySelector('[data-lp-benefit-text]');
        var btn = card.querySelector('[data-lp-benefit-more]');
        if (!text || !btn) return;
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var overflows = expanded || text.scrollHeight - text.clientHeight > 2;
        var small = window.matchMedia('(max-width: 989px)').matches;
        btn.hidden = !(small && overflows);
        if (!small) { text.classList.remove('is-expanded'); btn.setAttribute('aria-expanded', 'false'); btn.textContent = btn.getAttribute('data-more'); }
      });
    }
    cards.forEach(function (card) {
      var text = card.querySelector('[data-lp-benefit-text]');
      var btn = card.querySelector('[data-lp-benefit-more]');
      if (!text || !btn || btn.__lpInit) return;
      btn.__lpInit = true;
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        text.classList.toggle('is-expanded', !open);
        btn.textContent = open ? btn.getAttribute('data-more') : btn.getAttribute('data-less');
      });
    });
    measure();
    window.addEventListener('resize', measure);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
  }

  /* ---------- FAQ accordion: one open at a time, all closed on load ---------- */
  function initAccordions() {
    document.querySelectorAll('[data-lp-accordion]').forEach(function (root) {
      if (root.__lpInit) return;
      root.__lpInit = true;
      var items = root.querySelectorAll('.lp-accordion__item');
      function setOpen(item, open) {
        var btn = item.querySelector('.lp-accordion__trigger');
        item.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', String(open));
      }
      items.forEach(function (item) {
        item.querySelector('.lp-accordion__trigger').addEventListener('click', function () {
          var willOpen = !item.classList.contains('is-open');
          items.forEach(function (other) { setOpen(other, false); });
          if (willOpen) setOpen(item, true);
        });
      });
    });
  }

  /* ---------- Keep the chat bubble off the main CTAs (mobile and tablet, see CSS) ---------- */
  function initChatAvoid() {
    var targets = document.querySelectorAll('[data-lp-avoid-chat]');
    if (!targets.length || !('IntersectionObserver' in window)) return;
    var visible = new Set();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) visible.add(entry.target); else visible.delete(entry.target);
      });
      document.documentElement.classList.toggle('lp-avoid-chat', visible.size > 0);
    });
    targets.forEach(function (el) { io.observe(el); });
  }

  function init() {
    if (!document.querySelector('.lp')) return;
    bindScrollToBuyBox();
    bindReveal();
    initCountUp();
    initBuyBox();
    initSticky();
    initCarousels();
    initBenefits();
    initAccordions();
    initChatAvoid();
    document.dispatchEvent(new CustomEvent('lp:ready'));
  }

  window.LPVitality = window.LPVitality || { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
